"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "bread_crumbs-module__container___sZy6e",
  "crumb-content": "bread_crumbs-module__crumb-content___cdEm6",
  "crumb": "bread_crumbs-module__crumb___OSOn1",
  "ref": "bread_crumbs-module__ref___J9IMw",
  "tail": "bread_crumbs-module__tail___BnZAY",
  "right-arrow": "bread_crumbs-module__right-arrow___BL0Hz",
  "tut": "bread_crumbs-module__tut___vD3Q6"
};
class Crumb extends _react.PureComponent {
  static defaultProps = {
    tail: true,
    onClick: () => {}
  };
  render() {
    const {
      displayString,
      displayId,
      tail,
      type,
      onClick,
      zIndex
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles.crumb, type),
      onClick: onClick,
      style: {
        zIndex
      }
    }, tail && /*#__PURE__*/_react.default.createElement("span", {
      className: styles.tail
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayString: displayString,
      displayId: displayId,
      className: styles['crumb-content']
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: styles['right-arrow']
    }));
  }
}
class BreadCrumbs extends _react.Component {
  // TODO propTypes
  static propTypes = {
    type: T.oneOf(['ref', 'tut']).isRequired,
    crumbs: T.arrayOf(T.shape({
      displayString: T.string,
      displayId: T.string,
      onClick: T.func
    })).isRequired
  };
  render() {
    const {
      type,
      crumbs
    } = this.props;
    const crumbComponents = [];
    for (let crumb of crumbs) {
      const {
        displayString,
        displayId,
        onClick
      } = crumb;
      // Only the first crumb has the non-default style (color) and no tail
      const crumbType = !crumbComponents.length && type;
      const tail = Boolean(crumbComponents.length);
      crumbComponents.push( /*#__PURE__*/_react.default.createElement(Crumb, {
        onClick: onClick,
        key: displayString || displayId,
        displayString: displayString,
        displayId: displayId,
        tail: tail,
        type: styles[crumbType],
        zIndex: crumbs.length - crumbComponents.length // makes clicking the heads and tails a little more reasonable but not perfect
      }));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, crumbComponents);
  }
}
exports.default = BreadCrumbs;